var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 0C12.1002 0 11.374 0.726172 11.374 1.625V2.6C7.667 3.35156 4.87403 6.63203 4.87403 10.5625V11.5172C4.87403 13.9039 3.99551 16.2094 2.41114 17.9969L2.03536 18.4184C1.60879 18.8957 1.50723 19.5813 1.76622 20.1652C2.0252 20.7492 2.60918 21.125 3.24903 21.125H22.749C23.3889 21.125 23.9678 20.7492 24.2318 20.1652C24.4959 19.5813 24.3893 18.8957 23.9627 18.4184L23.5869 17.9969C22.0025 16.2094 21.124 13.909 21.124 11.5172V10.5625C21.124 6.63203 18.3311 3.35156 14.624 2.6V1.625C14.624 0.726172 13.8979 0 12.999 0ZM15.2994 25.0504C15.9088 24.441 16.249 23.6133 16.249 22.75H12.999H9.74903C9.74903 23.6133 10.0893 24.441 10.6986 25.0504C11.308 25.6598 12.1357 26 12.999 26C13.8623 26 14.69 25.6598 15.2994 25.0504Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications-active.450421d3350b78099ba0d77b15317bae.svg";
export { ForwardRef as ReactComponent };